import { createUseStyles } from 'react-jss';
import { ITheme } from '../../../components/theme';

type RuleNames =
  | 'mainInfo'
  | 'top'
  | 'bottom'
  | 'bottom1'
  | 'bottom2'
  | 'mainInfoTitle'
  | 'tabContent'
  | 'tab'
  | 'info'
  | 'buttonBlock'
  | 'buttonCancel'
  | 'buttonEdit'
  | 'paragraph'
  | 'title'
  | 'mainPic'
  | 'textBlock'
  | 'infoBlock'
  | 'goalsBlock'
  | 'copyText'
  | 'addressClick';

const PREFIX = 'MainInfo';
export const useStyles = createUseStyles<RuleNames, unknown, ITheme>(
  (theme: ITheme) => (
    {
      infoBlock: {
        width: 809,
        display: 'flex',
        flexDirection: 'column',
      },
      mainInfo: {
        display: 'flex',
        gap: 60,
        justifyContent: 'space-between',
      },
      top: {
        display: 'flex',
        justifyContent: 'space-between',
      },
      bottom: {
        display: 'flex',
        justifyContent: 'flex-start',
        gap: '7.8%',
      },
      bottom2: {
        width: '47.2%',
      },
      bottom1: {
        width: '45%',
      },
      mainInfoTitle: {
        fontFamily: theme.helveticaNeueBold,
        margin: 0,
        fontWeight: 700,
        fontSize: '24px',
        letterSpacing: '-0.5px',
        color: '#000000',
      },
      tab: {
        color: theme.darkGreen,
        background: '#E8EAEB',
        borderRadius: '10px',
        padding: '4px 12px',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '140%',
        display: 'flex',
        justifyContent: 'center',
        margin: 0,
      },
      tabContent: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        margin: '8px 0 20px',
        gap: 8,
      },
      info: {
        display: 'flex',
        alignItems: 'center',
        gap: '4%',
        '& h5': {
          color: 'rgba(0, 0, 0, 0.5)',
          fontSize: '16px',
          margin: '0 0 13px',
          width: '40%',
          fontWeight: 400,
        },
        '& p': {
          color: theme.darkGreen,
          fontSize: '16px',
          margin: '0 0 13px',
          width: '76%',
        },
      },
      buttonBlock: {
        width: 385,
        alignSelf: 'start',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '16px',
        whiteSpace: 'nowrap',
      },
      buttonCancel: {
        background: theme.white,
        borderRadius: '4px',
        color: theme.green,
        border: '1px solid #3B5D3E',
        fontSize: '14px',
        textTransform: 'uppercase',
        lineHeight: '24px',
        padding: '6px 16px',
        fontWeight: 600,
        cursor: 'pointer',
        '&:hover': {
          background: theme.hoverLightGreen,
        },
      },
      buttonEdit: {
        background: theme.lightGreen,
        borderRadius: '4px',
        color: theme.darkGreen,
        fontSize: '14px',
        textTransform: 'uppercase',
        lineHeight: '24px',
        padding: '6px 16px',
        fontWeight: 600,
        cursor: 'pointer',
        '&:hover': {
          background: theme.hoverLightGreen,
        },
      },
      paragraph: {
        color: 'rgba(0, 0, 0, 0.5)',
        fontSize: 14,
        margin: 0,
      },
      title: {
        fontSize: 20,
        margin: '0 0 8px',
      },
      mainPic: {
        width: 291,
        height: 249,
        borderRadius: '4px',
        objectFit: 'cover',
      },
      textBlock: {
        marginTop: 40,
      },
      goalsBlock: {
        maxWidth: '50%',
      },
      addressClick: {
        color: '#000000',
        cursor: 'pointer',
        textDecoration: 'none',
        '&:hover': {
          color: 'rgba(0, 0, 0, 0.5)',
        },
      },
      copyText: {
        cursor: 'pointer',
        '&:hover': {
          color: 'rgba(0, 0, 0, 0.5)',
        },
      },
    }
  ),
  { name: PREFIX },
);
